import React, { useEffect, useContext, useState, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { SocketContext } from '../../../context/SocketContext';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon, // in case you use it later
} from '@mui/icons-material/';

function ModalUnlockUser() {
  const { t } = useTranslation();

  const {
    updateShowModalUnlockUser,
    updateFocusOnMainScreen,
    updateLockUserInfo,
    lockUserInfo,
    parentInfo,
    userInfo,
    hall,
  } = useContext(AppContext);

  const { socket } = useContext(SocketContext);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);

  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  const hallRef = useRef(hall);
  useEffect(() => {
    hallRef.current = hall;
  }, [hall]);

  const [isUnlocked, setIsUnlocked] = useState(false);

  // Socket setup
  useEffect(() => {
    const handleUserLimitStatus = (data) => {
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
    };

    const handleUnlockUserStatus = (data) => {
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      setIsUnlocked(true);
    };

    socket.on('userLimitStatus', handleUserLimitStatus);
    socket.on('unlockUserStatus', handleUnlockUserStatus);
    return () => {
      socket.off('userLimitStatus', handleUserLimitStatus);
      socket.off('unlockUserStatus', handleUnlockUserStatus);
    };
  }, [socket, t]);

  const handleConfirm = () => {
    //updateShowModalUnlockUser(false);
    socket.emit('unlockUserStatus', {
      userID: parentInfoRef.current
        ? parentInfoRef.current.id
        : userInfoRef.current.id,
      bingoName: hallRef.current,
    });
  };

  const handleCancel = () => {
    updateFocusOnMainScreen(true);
    updateShowModalUnlockUser(false);
    updateLockUserInfo(false);
  };

  return (
    <>
      {lockUserInfo && (
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay">
            <div className="react-confirm-alert">
              {lockUserInfo.isBlockedToPlayDataBingo ? (
                <>
                  {!isUnlocked ? (
                    <div
                      className="react-confirm-alert-body"
                      style={{ width: '1000px' }}
                    >
                      <h1>{t('sales.unlockTitle')}</h1>
                      <p>{t('sales.unlockText1')}</p>
                      <p>
                        {' '}
                        <span
                          style={{
                            fontSize: '22px',
                            color: '#42a5f5',
                            fontWeight: 'bold',
                          }}
                        >
                          <>
                            {(() => {
                              const v = String(
                                lockUserInfo.lastTicketDataBingo ?? ''
                              );
                              const len = v.length;

                              if (len <= 4) return `CH - ${v}`;
                              if (len === 7) return `OK D. - ${v}`;
                              return `WG - ${v}`;
                            })()}
                            {lockUserInfo.bingoName
                              ? ` (${lockUserInfo.bingoName})`
                              : ''}
                          </>
                        </span>
                      </p>
                      <p>{t('sales.unlockText2')}</p>

                      <div
                        className="react-confirm-alert-button-group"
                        style={{ marginTop: '55px' }}
                      >
                        <button
                          className="btn-custom-yes"
                          onClick={handleConfirm}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                          }}
                        >
                          <CheckCircleIcon style={{ fontSize: '1.2em' }} />
                          {t('sales.confirm')}
                        </button>

                        <button
                          className="btn-custom-no"
                          onClick={() => {
                            handleCancel();
                          }}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px', // Space between icon and text
                          }}
                        >
                          <CancelIcon style={{ fontSize: '1.2em' }} />

                          {t('sales.cancel')}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="react-confirm-alert-body"
                      style={{ width: '1000px' }}
                    >
                      <h1>{t('sales.unlockedTitle')}</h1>
                      <p>{t('sales.unlockedText')}</p>
                      <div
                        className="react-confirm-alert-button-group"
                        style={{ marginTop: '55px' }}
                      >
                        <button
                          className="btn-custom-yes"
                          onClick={handleCancel}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                          }}
                        >
                          <CheckCircleIcon style={{ fontSize: '1.2em' }} />
                          {t('sales.confirm')}
                        </button>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div
                  className="react-confirm-alert-body"
                  style={{ width: '1000px' }}
                >
                  <h1>{t('sales.lockTitle')}</h1>
                  <p>{t('sales.lockText1')}</p>
                  <p>{t('sales.lockText2')}</p>
                  <div
                    className="react-confirm-alert-button-group"
                    style={{ marginTop: '55px' }}
                  >
                    <button
                      className="btn-custom-yes"
                      onClick={handleCancel}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                      }}
                    >
                      <CheckCircleIcon style={{ fontSize: '1.2em' }} />
                      {t('sales.confirm')}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ModalUnlockUser;
